import { ENV_DEV, ENV_PRE, ENV_PRO, ENV_TEST } from './environment';

let featureFlags = {};
let env = ENV_DEV;

const featureFlagsDev = {};

const featureFlagsPreprod = {};

const featureFlagsProd = {};

function init({ environment, initialFeatureFlags = {} } = {}) {
  env = environment;
  featureFlags = initialFeatureFlags;

  if (env === ENV_DEV) {
    featureFlags = { ...featureFlags, ...featureFlagsDev };
  }

  if (env === ENV_PRE) {
    featureFlags = { ...featureFlags, ...featureFlagsPreprod };
  }

  if (env === ENV_PRO) {
    featureFlags = { ...featureFlags, ...featureFlagsProd };
  }
}

function isActive(featureFlagName) {
  if (featureFlags[featureFlagName] != null) {
    return featureFlags[featureFlagName];
  }

  if (env !== ENV_PRO && env !== ENV_TEST) {
    throw new Error(`Missing Feature Flag ${featureFlagName}`);
  }

  return false;
}

function get() {
  return featureFlags;
}

export default {
  init,
  isActive,
  get,
};
